import PriceInterface from "../interface/priceInterface";
import ServiceCaller from "../../../services/ServiceCaller";

export default class InvoiceRepository {
    static async checkOrder(items: {
        id: string,
        name: string,
        count: string,
        price: string
    }[], shopId: string) {
        return new ServiceCaller().getService().checkOrders(items, shopId)
    }

    static async orderSet(shopId: string, price: PriceInterface, order: {
        products: {
            count: number,
            id: string,
            name: string,
            price: string,
        }[],
        payAt: string,
        rrn?: string,
        trace?: string,
    }, desk?: string) {
        return new ServiceCaller().getService().setOrder(shopId, price, order, desk)
    }
}